import React from 'react'
import PropTypes from 'prop-types'
import BaseField from './BaseField'

class InputField extends React.Component {
  	render () {
    	const { input, type, min, max, autoFocus, disabled,
      	className, placeholder, onChange } = this.props

    	return <BaseField {...this.props}>
			<input
				{...input}
				id={input.name}
				type={type}
				min={min}
				max={max}
				autoFocus={autoFocus}
				className={`c-input ${className}`}
				placeholder={placeholder}
				disabled={disabled}
				onChange={onChange || input.onChange}
			/>
		</BaseField>
  	}
}

InputField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.object
}

export default InputField



// WEBPACK FOOTER //
// ./src/components/form/InputField.js